/**
 * Sends the DOM `input` event a native field sends when the person changes it, for a control whose
 * own parts, such as a menu or a calendar, send none. The app's reload for a new release listens
 * for it, so a choice made in such a control is kept like typed text. Send it from a part that
 * stays on the page while the control does.
 */
export function markEdited(field: Element | null): void {
  field?.dispatchEvent(new Event('input', { bubbles: true }))
}
